import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {AuthService} from '../utils/services/auth.service';
import {WrapperComponent} from './components/wrapper/wrapper.component';

const appRoutes: Routes = [
  {
    path: '',
    component: WrapperComponent,
    canActivate: [AuthService],
    children: [
      {
        path: '',
        redirectTo: 'prices-view',
        pathMatch: 'full'
      },
      {
        path: 'prices-view',
        loadChildren: '../prices-view/prices-view.module#PricesViewModule',
      },
      {
        path: 'reimbursement-view',
        loadChildren: '../reimbursement-view/reimbursement-view.module#ReimbursementViewModule'
      },
      {
        path: 'payer-view',
        loadChildren: '../payer-view/payer-view.module#PayerViewModule'
      },
      {
        path: 'treatment-cost',
        loadChildren: '../treatment-cost/treatment-cost.module#TreatmentCostModule'
      },
      {
        path: 'view-map',
        loadChildren: '../view-map/view-map.module#ViewMapModule'
      }, 
      {
        path: 'all-inclusive',
        loadChildren: '../all-inclusive/all-inclusive.module#AllInclusiveModule'
      }
    ]
  },
  {
    path: 'login/:user/:token',
    component: WrapperComponent,
    canActivate: [AuthService]
  },
  // {
  //     path: '**',
  //     component: NotFoundComponent
  // }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRouterModule {
}
